module.exports = __webpack_public_path__ + "img/card_practicantes_internos.7f157cb7.svg";